import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);

    useEffect(() => {
        // CRITICAL: saat kembali dari OAuth Google, biarkan AuthCallback menukar session_id dulu.
        if (window.location.hash?.includes("session_id=")) return;
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(false));
    }, []);

    const login = async (identifier, password) => {
        const { data } = await api.post("/auth/login", { identifier, password });
        setUser(data);
        return data;
    };

    const loginWithGoogle = async (sessionId, context) => {
        try {
            const { data } = await api.post("/auth/google-session", { session_id: sessionId, context });
            setUser(data);
            return data;
        } catch (err) {
            setUser(false);
            throw err;
        }
    };

    const registerParent = async (payload) => {
        const { data } = await api.post("/auth/daftar-ulang", payload);
        if (!data.requires_approval) setUser(data);
        return data;
    };

    const logout = async () => {
        await api.post("/auth/logout");
        setUser(false);
    };

    const updateUser = (data) => setUser(data);

    return <AuthContext.Provider value={{ user, login, loginWithGoogle, registerParent, logout, updateUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
